module.exports = __webpack_public_path__ + "img/kerry-express.97919a46.png";